import { EditingProjectMediaImageRepositoryPathAdapter } from "@/shared/sync/mediaRepository/MediaImageRepositoryPathAdapter";
import { MediaImageRepository } from "./media_image_repository";
import { Project } from "@/shared/sync/dataTypes/Project";

export class MediaImageRepositoryProvider {
    private static instance: MediaImageRepository
    private static currentProjectId: string = ''

    public static getEditingProjectInstance(): MediaImageRepository {
        if (!this.instance) {
            this.instance = new MediaImageRepository('', new EditingProjectMediaImageRepositoryPathAdapter())
        }
        return this.instance
    }

    static getCurrentProjectId(): string {
        return this.currentProjectId
    }

    /**
     * Switch to a new project, cleaning up data from the previous project
     * to prevent IndexedDB bloat.
     * 
     * @param newProjectId - The new project ID to switch to
     * @param cleanupPreviousProject - If true, deletes previous project data from IndexedDB
     */
    static async switchToProject(newProjectId: string, cleanupPreviousProject: boolean = true): Promise<void> {
        const previousProjectId = this.currentProjectId
        
        // If switching to a different project, clean up the previous one
        if (previousProjectId && previousProjectId !== newProjectId) {
            if (cleanupPreviousProject) {
                // Full cleanup: delete from IndexedDB (this also revokes blob URLs)
                await this.clearEditingProjectInstance([newProjectId])
            } else {
                // Light cleanup: only revoke in-memory blob URLs, keep IndexedDB data
                await Project.cleanupMemoryForProjectId(previousProjectId);
            }
        }
        
        // Update to the new project
        this.currentProjectId = newProjectId
        this.instance.updateProjectId(newProjectId, new EditingProjectMediaImageRepositoryPathAdapter())
    }

    static async clearEditingProjectInstance(idsToPreserve: string[]): Promise<void> {
        await this.instance.clear(idsToPreserve)
    }

    private constructor() {
    }
}